import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { RedirectService } from '@app/_shared/_services/redirect.service';
import { environment } from '@environments/environment';
import { first } from 'rxjs/operators';

@Component({
  selector: 'auth-formlogin',
  templateUrl: './formlogin.component.html',
  styleUrls: ['./formlogin.component.scss']
})
export class AuthentificationFormloginComponent implements OnInit {

  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  error = '';
  environment = environment;
  queryParams
  @Input() withPassword:boolean;
  @Output() withPasswordChange:EventEmitter<any> = new EventEmitter<any>();
  
  // Impersonation
  impersonationUsers: any = {};
  impersonationUsersList: any[] = [];
  showImpersonation = false;
  selectedImpersonationUser: any = null;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private redirectService:RedirectService) { }

    ngOnInit() {
      this.loginForm = this.formBuilder.group({
          username: ['', Validators.required],
          password: ['', Validators.required]
      });

      let username = this.route.snapshot.queryParams.u;
      this.queryParams = this.route.snapshot.queryParams;

      if(username){
        this.loginForm.controls.username.setValue(username);
      }

      // Charger les utilisateurs d'impersonation en dev/test/val
      if(this.environment.env === 'development' || this.environment.env === 'test' || this.environment.env === 'val') {
        this.showImpersonation = true;
        this.loadImpersonationUsers();
      }
  }
  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit($event) {
    $event.stopPropagation();
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
          return;
      }

      this.loading = true;
      this.authenticationService.login(this.f.username.value, this.f.password.value)
          .pipe(first())
          .subscribe({
              next: () => {
                console.log('ok',this.route.snapshot.queryParams['returnUrl'] )

                // must also login into old cllaj
                // this.authenticationService.loginInOldSite(this.f.username.value, this.f.password.value).subscribe(res=>{})

                const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

                // if(!environment.adminOnly)
                this.redirectService.redirectToIndexWithPostParams(environment.cllajUrl + '/login.php', {email: this.f.username.value, password: this.f.password.value, redirect: location.protocol +'//' +location.host  + environment.baseHref + returnUrl})

                  // get return url from route parameters or default to '/'
                  // this.router.navigate([returnUrl]);
              },
              error: error => {
                  this.error = error;
                  if(typeof error === 'object'){
                    this.error = error.msg;
                  }
                  else{
                    this.error = error;
                  }
                  if(this.error == "Unauthorized"){
                    this.error = "Nom d'utilisateur ou mot de passe incorrect"
                  }
                  if(this.error == "unexist"){
                    this.error = "Cette adresse email n'existe pas."
                  }
                  if(this.error == "inscription not exist"){
                    this.error = "Cette adresse email n'est pas lié à une inscription."
                  }
                  if(this.error == "already exist"){
                    this.error = "Votre compte existe déjà."
                  }
                    this.loading = false;
              }
          });

  }
  goBack() {
    if(window){
    window.history.back();
    }
  }


  toggleWithPassword(){
    this.withPassword = !this.withPassword;
    this.withPasswordChange.emit(this.withPassword)
  }
  goToSignin(){
    console.log(this.route.snapshot.queryParams)
    if(!this.route.snapshot.queryParams)
    this.route.snapshot.queryParams = {};
    let qp = this.route.snapshot.queryParams;
    if(this.f.username.value)
    qp = { ...this.route.snapshot.queryParams, u : this.f.username.value}
    this.router.navigate(['/auth/signin'],{queryParams:qp})

    return false;
  }
  goToChangePassword(){
    let qp = {};
    if(this.f.username.value) {
      qp = { u: this.f.username.value };
    }
    this.router.navigate(['/auth/resetpassword'], { queryParams: qp });
    return false;
  }

  loadImpersonationUsers() {
    this.authenticationService.getImpersonationUsers()
      .subscribe({
        next: (res) => {
          this.impersonationUsers = res.usersByRole || {};
          // Créer une liste plate de tous les utilisateurs pour le select
          this.impersonationUsersList = [];
          Object.keys(this.impersonationUsers).forEach(category => {
            this.impersonationUsers[category].forEach(user => {
              // Créer les badges de type
              let typeBadges = [];
              if (user.isJeune) typeBadges.push('Jeune');
              if (user.isProprio) typeBadges.push('Proprio');
              if (user.isVisiteur) typeBadges.push('Visiteur');
              
              const typeInfo = typeBadges.length > 0 ? `[${typeBadges.join('/')}]` : '';
              const fullName = `${user.prenom || ''} ${user.nom || ''}`.trim() || 'Sans nom';
              
              this.impersonationUsersList.push({
                ...user,
                displayName: `${fullName} (${user.email}) ${typeInfo}`.trim(),
                mainRole: category,
                typeBadges: typeBadges
              });
            });
          });
          console.log('Impersonation users loaded', this.impersonationUsersList);
        },
        error: (err) => {
          console.error('Failed to load impersonation users', err);
          this.showImpersonation = false;
        }
      });
  }

  onImpersonationUserChange(event: any) {
    const userId = event.target.value;
    if (userId) {
      const user = this.impersonationUsersList.find(u => u.id == userId);
      if (user) {
        this.selectedImpersonationUser = user;
        // Remplir automatiquement les champs
        this.loginForm.controls.username.setValue(user.email);
        this.loginForm.controls.password.setValue('forcePWD2024Condorcet');
        console.log('Selected impersonation user:', user);
      }
    } else {
      this.selectedImpersonationUser = null;
      this.loginForm.controls.username.setValue('');
      this.loginForm.controls.password.setValue('');
    }
  }

}
